import React from "react";
import FirstCardModalityDetail from "./ModalityDetailCardChildren/firstCard";
import SecondCardModalityDetail from "./ModalityDetailCardChildren/secondCard";
import OriginalDataCard from "./ModalityDetailCardChildren/originalDataCard";

interface ModalityDetailCardProps {
  selectedModality: any;
  data: any;
  typeMoneyDescriptionList: any;
}

const ModalityDetailCard = ({
  selectedModality,
  data,
  typeMoneyDescriptionList,
}: ModalityDetailCardProps) => {
  const isRecalculate =
    data.modalidadRecalculada &&
    (selectedModality.respuestaMacro ||
      data.modalidadRecalculada.respuestaMacro);
  return (
    <>
      {/* primera card */}
      <FirstCardModalityDetail
        data={data}
        selectedModality={selectedModality}
        typeMoneyDescriptionList={typeMoneyDescriptionList}
        isRecalculate={isRecalculate}
      />
      {/* segunda card */}
      <SecondCardModalityDetail
        data={data}
        selectedModality={selectedModality}
      />
      {/* tercera card - Valores Originales (solo si fue recalculada) */}
      {isRecalculate && (
        <OriginalDataCard data={data} selectedModality={selectedModality} />
      )}
    </>
  );
};

export default ModalityDetailCard;
